module.exports = __webpack_public_path__ + "0228337a22ed1913bdd42efcd190e5a8.pdf";